import styled from 'styled-components';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
export var StyledScrollable = styled(OverlayScrollbarsComponent).withConfig({
  displayName: "Scrollablestyles__StyledScrollable",
  componentId: "sc-1187e3s-0"
})([""]);